module.exports = __webpack_public_path__ + "img/21.1ac66bcf.webp";